<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div v-show="visible">
    <v-btn class="productiontableshowicon" @click="toggleProductionlist()" fab small>
      <v-icon>
        mdi-table-search
      </v-icon>
    </v-btn>
    <div :class="productionlistStyle" v-show="productionlistVisible">
      <v-icon class="productiontablehideicon" @click="toggleProductionlist()">mdi-chevron-down</v-icon>
      <v-card>
        <v-card-title class="py-3">
          <div class="text-h6 text-sm-h4">
            {{ language.t("RobotPlotter.RbpProductionFloating.title") }}
          </div>
          <!-- <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            v-if="productionlistVisible && !isEmpty"
            @click="exportProduction()"
            >Export
          </v-btn> -->
        </v-card-title>
        <v-card-text v-if="!$vuetify.breakpoint.xsOnly"
          style="max-height: calc(50vh - 64px - 10px); overflow-y: scroll">
          <RBPProductionList ref="rbpProductionListx" v-on:setSelectedFromList="setSelectedFromList" />
        </v-card-text>
        <v-card-text v-else style="overflow-y: scroll">
          <RBPProductionList ref="rbpProductionListx" v-on:setSelectedFromList="setSelectedFromList" />
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="asBuildExport && hasAsBuildDrawing" small color="primary" :disabled="!hasAsBuildDrawing"
            @click="exportAsBuild(2)">
            {{ language.t("RobotPlotter.RbpProductionFloating.downloadAsBuild") }} 2D
          </v-btn>
          <v-btn v-if="asBuildExport && hasAsBuildDrawing" small color="primary" :disabled="!hasAsBuildDrawing"
            @click="exportAsBuild(3)">
            {{ language.t("RobotPlotter.RbpProductionFloating.downloadAsBuild") }} 3D
          </v-btn>
          <v-btn v-if="(asBuildExport || isPointProduction)" small :disabled="!hasAsBuildReport" color="primary"
            @click="selectHeaders = true">
            {{ language.t("RobotPlotter.RbpProductionFloating.gnssReport") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="selectHeaders" scrollable max-width="800">
      <v-card>
        <v-card-title>{{ language.t("RobotPlotter.RbpProductionFloating.selectHeaders") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          {{ language.t("RobotPlotter.RbpProductionFloating.selectedHeaders") }}
          <draggable class="list-group drag-inner-list pa-1" :list="selectedHeaders" group="headers">
            <v-chip class="ma-1" v-for="(item, i) in selectedHeaders" :key="i" draggable close color="primary"
              @click:close="removeHeader(i)">
              {{ (i + 1) + ": " + item.name }}
            </v-chip>
          </draggable>
        </v-card-text>
        <v-card-text max-width="400">
          {{ language.t("RobotPlotter.RbpProductionFloating.deselectedHeaders") }}
          <draggable class="list-group drag-inner-list pa-1" :list="nonSelectedHeaders" group="headers">
            <v-chip class="ma-1" v-for="(item, i) in nonSelectedHeaders" :key="i" draggable>
              {{ item.name }}
            </v-chip>
          </draggable>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="selectHeaders = false">
            {{ language.t("RobotPlotter.RbpProductionFloating.close") }}
          </v-btn>
          <v-btn :loading="downloadingReport" color="blue darken-1" text @click="exportAsBuildReport()">
            {{ language.t("RobotPlotter.RbpProductionFloating.download") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AsBuildReport from "../../models/AsBuildReport";
import RBPProductionList from "./ProductionList.vue";
import draggable from 'vuedraggable'

export default {
  components: {
    RBPProductionList,
    draggable,
  },
  data: () => ({
    callback: null,
    visible: false,
    productionlistVisible: false,
    data: {},
    downloadingReport: false,

    asBuildExport: false,
    isPointProduction: false,

    asBuildReportHeaders: [...Array(16).keys()],
    selectHeaders: false,

    selectedHeaders: [{
      name: 'Name (PntNmr)',
      value: 0,
    }, {
      name: 'LogReference',
      value: 1,
    }, {
      name: 'DateTime',
      value: 2,
    }, {
      name: 'Latitude',
      value: 3,
    }, {
      name: 'Longitude',
      value: 4,
    }, {
      name: 'X',
      value: 5,
    }, {
      name: 'Y',
      value: 6,
    }, {
      name: 'Heading',
      value: 7,
    }, {
      name: 'Height',
      value: 8,
    }, {
      name: 'GNSSQuality',
      value: 9,
    }, {
      name: 'GNSS-RMS',
      value: 10,
    }, {
      name: 'GNSS-HDOP',
      value: 11,
    }, {
      name: 'GNSS-VDOP',
      value: 12,
    }, {
      name: 'GNSS-PDOP',
      value: 13,
    }, {
      name: 'GNSS-AccuracyH',
      value: 14,
    }, {
      name: 'GNSS-AccuracyV',
      value: 15,
    },],
    nonSelectedHeaders: [],
  }),
  props: {},
  watch: {
    selectedHeaders(val, oldVal) {
      console.log(val);
      console.log(oldVal);
    }
  },
  methods: {
    removeHeader(index) {
      var header = this.selectedHeaders.splice(index, 1);
      this.nonSelectedHeaders.push(...header);
    },
    exportProduction() {
      console.log("not implemented");
      return;
      if (!this.data) return;
      var _this = this;
      console.log(_this.data);
      this.$axios
        .get(route("api.production.rpr.excel"), {
          params: _this.data,
          responseType: "blob",
        })
        .then((response) => {
          // TODO: check status
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          // TODO: better filename
          fileLink.setAttribute("download", "export.xlsx");
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    getProduction(devices, task, start, end, target, callback = null) {
      this.data = {
        devices: devices,
        task: task,
        startdate: start,
        enddate: end,
      };
      this.callback = callback;
      this.$refs.rbpProductionListx.getProduction(devices, task, start, end, target, true, this.productionLoaded);
    },
    productionTablePlaceholder() {
      console.log("show production placeholder")
      this.$refs.rbpProductionListx.placeholder = true;
      this.visible = true;
    },
    setSelectedFromLine(id) {
      this.$refs.rbpProductionListx.setSelectedFromLine(id);
    },
    setSelectedFromList(id) {
      this.$emit("selectProduction", id);
    },
    deselectRow() {
      this.$refs.rbpProductionListx.deselectRow();
    },
    productionLoaded(success) {
      if (this.callback != null) this.callback(success);
      // if the production is empty hide the floating table
      console.log('check empty');
      if (this.$refs.rbpProductionListx.isEmpty()) {
        this.visible = false;
      } else {
        this.visible = true;
      }

      this.asBuildExport = this.$refs.rbpProductionListx.asBuildExport;
      this.isPointProduction = this.$refs.rbpProductionListx.isPointProduction;
    },
    exportAsBuild(demensions = 2) {
      this.$axios
        .get(route("api.tasks.exportsurvey", [this.data.task, demensions]), {
          responseType: "blob",
        })
        .then((response) => {
          // TODO: check status
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          // TODO: better filename
          var filename = "asbuild.dxf"

          fileLink.setAttribute("download", filename);
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    exportAsBuildReport() {
      this.downloadingReport = true;
      this.$axios
        .get(route("api.tasks.exportsurveyreport", [this.data.task, 1]))
        .then(async (res) => {
          var data = []
          data.push(...(res.data.data));

          var _this = this;
          async function appendReportData(currentData, currentPage) {
            const { data: exportSurveyPage } = await _this.$axios.get(route("api.tasks.exportsurveyreport", [_this.data.task, currentPage + 1]))
            currentData.push(...(exportSurveyPage.data))
            if (exportSurveyPage.next_page_url) {
              await appendReportData(currentData, exportSurveyPage.current_page)
            }
            return;
          }

          if (res.data.next_page_url) {
            await appendReportData(data, res.data.current_page)
          }

          var rptimepositions = []
          data.forEach(rptimepositionlog => {
            rptimepositionlog.rptimepositions.forEach(rptimeposition => {
              rptimeposition.logReference = rptimepositionlog.description;
              rptimepositions.push(rptimeposition)
            })
          });

          let taskRes = await this.$axios.get(route('api.task', this.data.task));

          var report = new AsBuildReport(taskRes.data.name, taskRes.data.projection, rptimepositions);

          var headers = []
          this.selectedHeaders.forEach(header => {
            headers.push(header.value);
          });

          var fileLink = document.createElement("a");
          fileLink.id = 'download-csv'

          fileLink.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(report.getAsBuildReport(headers)));
          fileLink.setAttribute('download', taskRes.data.name + '.csv');
          document.body.appendChild(fileLink);

          fileLink.click();
          this.downloadingReport = false;
        });
    },
    empty() {
      this.productionlistVisible = false;
      this.visible = false;
      this.$refs.rbpProductionListx.empty();
    },
    toggleProductionlist() {
      this.productionlistVisible = !this.productionlistVisible;

      if (this.productionlistVisible && this.$vuetify.breakpoint.xsOnly) {
        this.$emit("changePopup", "productionlist");
      }
    },
    hideProductionlist() {
      this.productionlistVisible = false;
    },
  },
  computed: {
    hasAsBuildDrawing() {
      return this.$auth.functionGroups.includes(3)
    },
    hasAsBuildReport() {
      return this.$auth.functionGroups.includes(10)
    },
    productionlistStyle: function () {
      return {
        floating: this.productionlistVisible && !this.$vuetify.breakpoint.xsOnly,
        hidden: !this.productionlistVisible,
        popup: this.productionlistVisible && this.$vuetify.breakpoint.xsOnly,
      };
    },
    isEmpty: function () {
      // if (this.productionlistVisible)
      return this.$refs.rbpProductionListx.isEmpty();
    }
  },
};
</script>

<style scoped>
.floating {
  z-index: 75;
  position: absolute;
  bottom: 10px;
  right: 10px;
  min-width: 800px;
}

.popup {
  z-index: 202;
  position: absolute;
  top: 0px;
  max-height: 80vh;
  width: 100vw !important;
}

.hidden {
  display: none;
}

.productiontablehideicon {
  z-index: 70;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
}

.productiontableshowicon {
  z-index: 70;
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.drag-inner-list {
  min-height: 100px;
  background-color: #f8f8f8;
  overflow: auto;
  box-shadow: 0.3px 0.3px 2.5px gray;
}
</style>